export const CAMPAIGN_TAG = 'HolidaySeason'
export const CAMPAING_TAB_ANIMATION_ENABLED = false
